export default __webpack_public_path__ + "static/media/helpful-resources-page--mobile@2x.d47f9349.webp";